const TRIAL_MODE_KEY = "extemp_trial_mode";

export function enableTrialMode() {
  try {
    localStorage.setItem(TRIAL_MODE_KEY, "true");
  } catch {}
}

export function disableTrialMode() {
  try {
    localStorage.removeItem(TRIAL_MODE_KEY);
  } catch {}
}

export function isTrialModeEnabled() {
  try {
    return localStorage.getItem(TRIAL_MODE_KEY) === "true";
  } catch {
    return false;
  }
}
